import { render, staticRenderFns } from "./GdashGauge.vue?vue&type=template&id=264edb0c"
import script from "./GdashGauge.vue?vue&type=script&lang=js"
export * from "./GdashGauge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports